/* eslint-disable prettier/prettier */
// Import gsap
import { gsap } from "gsap";

export default class AnimateImage {    

    static animateImage = (function() {
       // ANIMATE IMAGE  
        const tl = gsap.timeline({
            scrollTrigger: {
            trigger: '.whoAnimate', // trigger su chi siamo
            pin: true,//'.container-main',
            scrub: 0.5,
            start: "top 30%",
                end: "60% center",
            /*markers: {
                startColor: "black",
                endColor: "blu"
            },*/
            }
        });
        tl.add('start')
        tl.fromTo('.whoAnimate img', {
            x: '100%',
            opacity: 0,
        }, {
            ease: "none",
            x: 0,
            opacity: 1,
            bottom:'100%',
            stagger: 1,
            duration:3,
        }, 'start');
    });    


    static animateImageService = (function() {
       // ANIMATE SERVIZI: ogni servizio nasce da destra, i dispari da sinistra
        const services = gsap.utils.toArray('#servizi .service');
        services.forEach((service, i) => {
            const isOdd = i % 2 === 0; // nth-child(odd): 1, 3, 5... => index 0, 2, 4...
            gsap.fromTo(service.querySelector('aside img'), {
                x: isOdd ? '-100%' : '100%',
                opacity: 0,
            }, {
                ease: "none",
                x: 0,
                opacity: 1,
                scrollTrigger: {
                    trigger: service,
                    scrub: 0.5,
                    start: "top 90%",
                    end: "top 40%",
                }
            });
        });
    });

    static animateImageTeam = (function() {
       // ANIMATE TEAM: ogni immagine si anima singolarmente, una alla volta, al proprio scroll
        const teams = gsap.utils.toArray('.team-wrapper .team');
        teams.forEach((team) => {
            gsap.fromTo(team.querySelector('img'), {
                opacity: 0,
            }, {
                ease: "none",
                opacity: 1,
                scrollTrigger: {
                    trigger: team,
                    scrub: 0.5,
                    start: "top 90%",
                    end: "top 40%",
                }
            });
        });
    });

    static animateImageSvg = (function() {
       // ANIMATE SVG: ogni immagine nasce da 0 alla sua dimensione con effetto rimbalzo
        const strenghts = gsap.utils.toArray('.strenghts-wrapper .strenghts');
        strenghts.forEach((strenght) => {
            gsap.fromTo(strenght.querySelector('aside img'), {
                scale: 0,
                opacity: 0,
                transformOrigin: "center center",
            }, {
                ease: "bounce.out",
                scale: 1,
                opacity: 1,
                duration: 1,
                scrollTrigger: {
                    trigger: strenght,
                    start: "top 90%",
                    once: true,
                }
            });
        });
    });

     static animateImageHomeShowroom = (function() {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.home-showroom', // trigger su chi siamo
                pin: true,//'.container-main',
                scrub: 0.5,
                start: "top 10%",
                end: "60% center",
                /*markers: {
                    startColor: "black",
                    endColor: "black"
                },*/
            }
        });
         tl.add('start')
        tl.fromTo('.home-showroom img', {
            scale: 0,
            opacity: 0,
            transformOrigin: "center center",
        }, {
            ease: "none",
            scale: 1,
            opacity: 1,
            stagger: 1,
            duration:3,
        }, 'start');
        tl.fromTo('.home-showroom h3, .home-showroom-text, .home-showroom-btn', {
            y: '50',
            opacity: 0,
        }, {
            ease: "none",
            y: 0,
            opacity: 1,
            stagger: 1,
            duration:3,
        }, 'start');
     });

   
    static init(){
        let media = gsap.matchMedia();
        media.add("(min-width: 981px)", () => {
            AnimateImage.animateImage();
            AnimateImage.animateImageService();
            AnimateImage.animateImageHomeShowroom();
            AnimateImage.animateImageTeam();
            AnimateImage.animateImageSvg();
        })
        
    }    
    
}


